<template>
  <div>

    <v-row class="title-wrap">
      <v-col v-if="$route.meta.contType === 'C'" cols="12" class="icon-title">연봉계약서</v-col>
      <v-col v-if="$route.meta.contType === 'H'" cols="12" class="icon-title">근로계약서</v-col>
      <v-col v-if="$route.meta.contType === 'F'" cols="12" class="icon-title">전적동의서</v-col>
    </v-row>

    <div class="overflow-y-auto">

      <v-list v-if="list.length > 0">
        <v-list-item-group color="primary">
          <v-list-item v-for="(item, i) in list" :key="i" class="gntType-item" @click="selectMenu(item)">
            <v-list-item-title>
              <span :class="item.signed === 'Y' ? 'grey--text' : ''">{{ item.contName }}</span>
            </v-list-item-title>

            <v-list-item-icon v-if="item.signed === 'Y'">
              <v-btn outlined x-small color="green">서명완료</v-btn>
            </v-list-item-icon>
            <v-list-item-icon v-else-if="item.signed === 'I'">
              <v-btn outlined x-small color="primary">서명중</v-btn>
            </v-list-item-icon>
            <v-list-item-icon v-else>
              <v-btn outlined x-small color="grey">서명안됨</v-btn>
            </v-list-item-icon>

          </v-list-item>
        </v-list-item-group>
      </v-list>
      <!-- 계약서 목록 없는 경우 -->
      <v-list v-if="list.length === 0">
        <v-list-item>확인 가능한 문서가 없습니다</v-list-item>
      </v-list>
    </div>

    <v-dialog v-if="isShowDialog" v-model="isShowDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card height="100%">
        <v-toolbar fixed flat>
          <v-btn icon @click="isShowDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn icon @click="firstPage">
            <v-icon>mdi-arrow-collapse-left</v-icon>
          </v-btn>
          <v-btn icon @click="prevPage">
            <v-icon>mdi-arrow-left-bold-circle</v-icon>
          </v-btn>
          <v-btn icon @click="nextPage">
            <v-icon>mdi-arrow-right-bold-circle</v-icon>
          </v-btn>
          <v-btn icon @click="lastPage">
            <v-icon>mdi-arrow-collapse-right</v-icon>
          </v-btn>
          <v-btn icon @click="zoomIn">
            <v-icon>mdi-magnify-plus-outline</v-icon>
          </v-btn>
          <v-btn icon @click="zoomOut">
            <v-icon>mdi-magnify-minus-outline</v-icon>
          </v-btn>
        </v-toolbar>
        <div id="crownix-viewer" style="width : 100%; margin-top : 44px;"></div>
        <div id="signpad"></div>
        <v-footer fixed height="60">
          <v-row justify="end">
            <v-btn v-if="isShowCancelButton" id="cancelSign" color="white" class="mr-2" @click="cancelSign">서명취소</v-btn>
            <v-btn v-if="isShowSaveSignButton" id="saveSign" color="green" class="white--text" @click="saveSign">서명저장</v-btn>
            <v-btn v-if="isShowStartSignButton" id="startSign" color="green" class="white--text" @click="startSign">서명하기</v-btn>
          </v-row>
        </v-footer>
      </v-card>

    </v-dialog>

  </div>
</template>
<script>
import { loadScript } from 'vue-plugin-load-script';
import { mapGetters } from 'vuex';
import {getContract} from '@/api/contract';
import {encrypt, getPageSignData, saveSign, checkSign} from '@/api/rd';
import {signUpload} from '@/api/sign';
import viewer from "@/store/modules/ela/elaViewerStore";

//연봉계약서

export default {
  name : 'contract'
  , computed : {
    ...mapGetters(['GET_USER_DATA'])
    , scrollViewStyle() {
      return `max-height: ${
          window.innerHeight - this.$store.getters.HEIGHT_TITLE_BOTTOM_BTN
      }px;`;
    }
  }
  , data : () => ({
    list : []
    , isShowDialog : false
    , viewer : null
    , signpad : null
    , isShowStartSignButton : false
    , isShowSaveSignButton : false
    , isShowCancelButton : false
  })
  , created() {
    this.searchContract();
  }
  , methods : {
    searchContract(){
      getContract({
        enterCd : this.$store.getters.GET_USER_DATA.ssnEnterCd
        , sabun : this.$store.getters.GET_USER_DATA.ssnSabun
        , contType : this.$route.meta.contType
      }).then((response) => {
        this.list = response.data;
      });
    }
    , async selectMenu(item){
      this.isShowDialog = true;
      this.loadCrownix(item);
      // await this.getEncrypt(item);
      // await this.startSignpad(item);
    }
    , loadCrownix(item){
      loadScript(
          process.env.VUE_APP_RD_URL + '/ReportingServer/html5/js/crownix-viewer.min.js',
          //'https://mhr.bgf.co.kr/ReportingServer/html5/js/crownix-viewer.min.js',
      ).then((e) => {
        // console.log('crownix loaded');
        this.getEncrypt(item);
      });
    }
    , getEncrypt(item){
      encrypt({
        enterCd : this.$store.getters.GET_USER_DATA.ssnEnterCd
        , sabun : this.$store.getters.GET_USER_DATA.ssnSabun
        , localCd : ''
        , parameterType : 'rv'
        , param1 : item.rdMrd
        , param2 : item.rk
      }).then((response) => {
        this.viewer = new window.m2soft.crownix.Viewer(
            process.env.VUE_APP_RD_URL + '/ReportingServer/service',
            //'https://mhr.bgf.co.kr/ReportingServer/service',
            'crownix-viewer',
        );
        this.viewer.setParameterEncrypt(11);
        this.viewer.openFile(response.data.path, response.data.encryptParameter, {showPageNum : 2});
        this.viewer.hideToolbar();
        this.startSignpad(item);
      });
    }
    //서명하기 버튼 이벤트
    , startSign(){
      this.signpad.changeStatus('signing');
      this.changeButtonStatus();
    }
    //서명저장 버튼 이벤트
    , saveSign(){
      this.saveContractSign();
    }
    //서명취소 버튼 이벤트
    , cancelSign(){
      this.signpad.changeStatus('unsigned');
      this.signpad.clear();
      this.changeButtonStatus();
    }
    , startSignpad(item){
      const _this = this;
      this.signpad = new SignPad({
        id : 'signpad'
        , signButton : 'startSign'
        , saveButton : 'saveSign'
        , cancelButton : 'cancelSign'
        , viewer : _this.viewer
        , signpadItem : item
      });

      if(item.signUseYn !== 'Y'){
        this.signpad.disable();
        return;
      }

      //페이지별 서명
      if(item.pageSignYn === 'Y'){
        this.signpad.pagination({
          exceptPage : item.exceptPage ? item.exceptPage.split(',') : []
          , pageMove : function(pageNumber){
            _this.isShowStartSignButton = _this.signpad.isShowSignButton;
            _this.isShowCancelButton = _this.signpad.isShowCancelButton;
            _this.isShowSaveSignButton = _this.signpad.isShowSaveButton;
          }
          , callback : function(pageNumber){
            _this.searchSignData(item, pageNumber);
          }
        });
      }
      //통합 서명
      else{
        this.signpad.integration(function(lastPageNumber){
          _this.searchSignData(item, lastPageNumber);
        });
      }
    }
    , searchSignData(item, pageNumber){
      getPageSignData({
        contType : item.contType
        , stdDate : item.stdDate
        , sabun : item.sabun
        , pageSeq : pageNumber
        , enterCd : item.enterCd
      }).then((response) => {
        if(!response.data) this.signpad.accept();
        else this.signpad.complete();

        this.changeButtonStatus();
      });
    }
    , changeButtonStatus(){
      this.isShowStartSignButton = this.signpad.isShowSignButton;
      this.isShowSaveSignButton = this.signpad.isShowSaveButton;
      this.isShowCancelButton = this.signpad.isShowCancelButton;
    }
    //사인 파일 저장
    , saveContractSign(){
      const _this = this;
      //1. 서명 이미지 파일 저장 /mobile/api/file/sign
      signUpload({
        enterCd : _this.$store.getters.GET_USER_DATA.ssnEnterCd
        , sabun : _this.$store.getters.GET_USER_DATA.ssnSabun
        , sign : _this.signpad.getSign()
      }).then((response) => {
        if(response.data.Code !== 0){
          alert(response.data.Message);
          return;
        }

        //2. 서명 데이터 DB 저장
        this.saveContract(response.data.FileSeq);
      });
    }
    , saveContract(fileSeq){
      const _this = this;
      const userData = this.$store.getters.GET_USER_DATA;
      const signpadItem = this.signpad.signpadItem;
      saveSign({
        enterCd : userData.ssnEnterCd
        , sabun : userData.ssnSabun
        , contType : signpadItem.contType
        , stdDate : signpadItem.stdDate
        , pageSeq : signpadItem.pageSignYn === 'Y' ? _this.signpad.currentPage : _this.signpad.totalPage
        , agreeYn : 'Y'
        , memo : ''
        , fileSeq : fileSeq
        , pageSignYn : signpadItem.pageSignYn
      }).then((response) => {
        if(response.data.Message && signpadItem.pageSignYn !== 'Y' && response.data.code > 0){
          this.completeSign();
          return;
        }
        if(response.data.Code > 0 && signpadItem.pageSignYn === 'Y'){
          //3. 서명 완료 체크 -> 페이지별 서명인 경우에만 서명 완료 체크한다
          this.checkContractSign(fileSeq);
        }
      });
    }
    , checkContractSign(fileSeq){
      const userData = this.$store.getters.GET_USER_DATA;
      const signpadItem = this.signpad.signpadItem;
      const _this = this;
      checkSign({
        enterCd : userData.ssnEnterCd
        , contType : signpadItem.contType
        , stdDate : signpadItem.stdDate
        , totalPage : _this.signpad.totalPage
        , exceptPage : _this.signpad.exceptPage
        , sabun : userData.ssnSabun
        , fileSeq : fileSeq
      }).then((response) => {
        // if(response.data.Message) alert(response.data.Message);
        if(response.data.Code > 0){
          //서명이 완료되면 서명 완료 처리
          // contType : item.contType
          //     , stdDate : item.stdDate
          //     , sabun : item.sabun
          //     , pageSeq : pageNumber
          //     , enterCd : item.enterCd
          this.searchSignData({
            contType : signpadItem.contType
            , stdDate : signpadItem.stdDate
            , sabun : userData.ssnSabun
            , enterCd : userData.ssnEnterCd
          }, _this.signpad.currentPage);
          this.completeSign(response);
        }
      });
    }
    , completeSign(response){
      // this.isShowDialog = false;
      if(response.data.Complete === 'Y'){
        alert('서명이 모두 완료되었습니다.');
        this.isShowDialog = false;
      }
      this.searchContract();
    }
    , firstPage(){
      this.viewer.moveFirstPage();
    }
    , prevPage(){
      this.viewer.prevPage();
    }
    , nextPage(){
      this.viewer.nextPage();
    }
    , lastPage(){
      this.viewer.moveLastPage();
    }
    , zoomIn(){
      this.viewer.zoomIn();
    }
    , zoomOut(){
      this.viewer.zoomOut();
    }
  }
}
</script>
<style>
.crownix-dialog-message:nth-child(2){
  display: block !important;
  position:absolute;
  top:70px;
}
.crownix-dialog-message:nth-child(3){
  display: none !important;
}
</style>